import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "v-profile-dashboard" }
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = { class: "col-lg-8 divide-line no-gutters m-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Here’s what’s happening with your account today.", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row divide-line no-gutters m-0" }
const _hoisted_9 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_10 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_11 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = {
  key: 0,
  class: "col-lg-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_loading = _resolveComponent("v-loading")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_dashboard_reporting = _resolveComponent("dashboard-reporting")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_loading, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", null, "Hello, " + _toDisplayString(_ctx.userFirstName()), 1),
                _hoisted_6
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.accessPurchaseTile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_v_card, {
                        icon: "shopping-cart",
                        headerTitle: "Buy",
                        route: {name: 'Buying'},
                        count: _ctx.ordersCount || '0',
                        title: "Items purchased"
                      }, null, 8, ["count"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.accessSellTile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_v_card, {
                        icon: "tag",
                        headerTitle: "Sell",
                        route: {name:'Selling'},
                        count: _ctx.itemsCount || '0',
                        title: "Items for sale"
                      }, null, 8, ["count"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.accessAuctionTile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_v_card, {
                        icon: "gavel",
                        headerTitle: "Auctions",
                        route: {name: 'Auctions', params: {status: 'active'}},
                        count: _ctx.wonAuctionsCount || '0',
                        title: "Auction Lots Won"
                      }, null, 8, ["count"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_v_card, {
                    icon: "user-circle",
                    headerTitle: "Account Settings",
                    route: {name: 'Management'},
                    middleIcon: "user",
                    title: "Update your account information"
                  })
                ])
              ])
            ])
          ]),
          (_ctx.viewReports)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_v_card, {
                  class: "mb-1",
                  icon: "line-chart",
                  headerTitle: "Reports"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dashboard_reporting)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}